'use client'

// src/constants.ts
var SECTIONS_LIMIT = 9;

export {
  SECTIONS_LIMIT
};
//# sourceMappingURL=chunk-HVHRQLH6.mjs.map